import { z } from 'zod'
import { financeSearchSchema } from './finance-search.ts'

export const groupReceiptSearchSchema = z.object({
  target: z.discriminatedUnion('mode', [
    z.object({ mode: z.literal('ids'), ids: z.array(z.number().int().positive()).min(1).max(100) }),
    z.object({ mode: z.literal('search'), search: financeSearchSchema })
  ])
})
